import type { SectionTone } from '../../shell/sectionBar';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the director steps; each part uses its own slice of it */
import styles from '../DirectorSteps.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The dot class of a section colour (design `.dot.s-*`). */
export const SECTION_DOT: Readonly<Record<SectionTone, string>> = {
  intro: styles.dotIntro ?? '',
  verse: styles.dotVerse ?? '',
  chorus: styles.dotChorus ?? '',
  bridge: styles.dotBridge ?? '',
  outro: styles.dotOutro ?? '',
};
